


























































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import HorizontalWorkflowJobTabs from '@/components/workflow/HorizontalWorkflowJobTabs.vue';
import VerticalWorkflowJobTabs from '@/components/workflow/VerticalWorkflowJobTabs.vue';
import WorkflowButtons from '@/components/workflow/WorkflowButtons.vue';
import DocumentViewer from '@/components/shared/DocumentViewer.vue';
import {
  WorkflowJobTabModel,
  DynamicFormValidationModel,
  JobTabOrientation,
  WorkflowStandardProcessingAction,
  DocumentViewerConstants,
  NotificationConstants,
  EditReferencesButtonTooltipModel,
  DocumentSearchModel,
  WorkflowJobModel,
  ComponentConstants,
  Workflow,
  StoreConstants
} from '@/types';
import WorkflowJobLock from '@/components/workflow/WorkflowJobLock.vue';
import Splitpanes from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import { ModalHelpers, ArrayHelper, DefaultWorkflowJob, GetNextJobs, FormFieldValidation } from '@/mixins';
import { EventBus } from '@/classes/EventBus';
import store from '@/store';

export default Vue.extend({
  name: 'DefaultWorkflowJob',
  mixins: [ModalHelpers, ArrayHelper, DefaultWorkflowJob, GetNextJobs],
  props: {
    beforeJobProcessAction: {
      type: Function,
      default: undefined
    }
  },
  data() {
    return {
      isLoading: false,
      leftPaneSize: 0,
      rightPaneSize: 0,
      lastActivity: new Date(),
      processingAction: WorkflowStandardProcessingAction.ProcessJob
    };
  },
  methods: {
    ...mapActions('workflowJobStore', [
      'setActiveHorizontalTab',
      'setActiveVerticalTab',
      'setDynamicFormValidationModel',
      'setIsAwaitingProcessing',
      StoreConstants.WorkflowJob.Actions.SetIsTabProcessing
    ]),
    ...mapActions('userPreferencesStore', ['setJobVerticalSlider', 'setCanGetNextJob']),
    ...mapActions('workflowQueueStore', ['setNextJobsList']),
    userActivity(this: any) {
      this.lastActivity = new Date();
    },
    onDeleteDocument(this: any, documentSearchModel: DocumentSearchModel) {
      this.reloadRelatedDocumentsTab(documentSearchModel);
    }
  },
  watch: {
    awaitingProcessing(this: any, value: boolean) {
      if (value) {
        this.setIsAwaitingProcessing(false);
        this.processWorkflowJob();
      }
    },
    invalidWorkflowTabs(this: any, tabs: WorkflowJobTabModel[]) {
      if (tabs.length > 0) {
        this.isLoading = false;
        this[StoreConstants.WorkflowJob.Actions.SetIsTabProcessing](false);
        const firstInvalidHorizontalTab = tabs.find((x: WorkflowJobTabModel) => x.jobTabOrientation === JobTabOrientation.Horizontal);
        if (firstInvalidHorizontalTab && this.activeHorizontalTab.key !== firstInvalidHorizontalTab.key) {
          this.setActiveHorizontalTab(firstInvalidHorizontalTab.key);
        }
        const firstInvalidVerticalTab = tabs.find((x: WorkflowJobTabModel) => x.jobTabOrientation === JobTabOrientation.Vertical);
        if (firstInvalidVerticalTab && this.activeVerticalTab.key !== firstInvalidVerticalTab.key) {
          this.setActiveVerticalTab(firstInvalidVerticalTab.key);
        }
      }
      FormFieldValidation.methods.setFocusOnInvalidField(this);
    }
  },
  created(this: any) {
    this.initializePaneSize();
    this.initializeCanGetNextJob();
    this.initializeTheTabs();
    EventBus.$on('dynamic-form-validated', (dynamicFormValidationModel: DynamicFormValidationModel) => {
      this.setDynamicFormValidationModel(dynamicFormValidationModel);
    });
    this.documentToolbarOptions = DocumentViewerConstants.DocumentViewerDeleteEnabledToolOptions;
    this.documentToolbarOptions.showEditReferences = true;
  },
  beforeDestroy() {
    EventBus.$off('dynamic-form-validated');
  },
  computed: {
    ...mapGetters('workflowJobStore', [
      'workflowJob',
      'isWorkflowJobLocked',
      'isDirty',
      'workflowQueueConfiguration',
      'hasHorizontalWorkflowJobTabs',
      'hasVerticalWorkflowJobTabs',
      'workflowJobTabsByOrientation',
      'hasWorkflowTabs',
      'activeHorizontalTab',
      'activeVerticalTab',
      'allJobTabsByOrientation',
      'hasHorizontalJobTabs',
      'hasVerticalJobTabs',
      'dirtyJobTabStates',
      'dirtyHorizontalJobTabStates',
      'dirtyVerticalJobTabStates',
      'invalidWorkflowTabs',
      'validWorkflowTabs',
      'workflowJobTabs',
      'visibleWorkflowJobTabs',
      'hasVisibleWorkflowTabs',
      'visibleCustomJobTabsThatNeedValidating',
      'dynamicFormValidationModel',
      'allTabsValid',
      'isAwaitingProcessing',
      'isWorkFlowJobDirty',
      'workflowDocumentIsPlaceholder'
    ]),
    ...mapGetters('userPreferencesStore', ['getWorkflowJobPreferences']),
    ...mapGetters('workflowQueueStore', ['getNextJobsLists', 'getTableStateField']),
    awaitingProcessing(this: any) {
      if (this.allTabsValid && this.isAwaitingProcessing) {
        return true;
      }
      return false;
    },
    isDocumentLoadingOrBeingConverted(this: any) {
      return store.getters['documentViewStore/document'].isBeingConverted || store.getters['documentViewStore/isPageLoading'];
    },
    documentPlaceholder(this: any) {
      return {
        showDocumentPlaceholder: this.workflowDocumentIsPlaceholder,
        documentPlaceholderText: NotificationConstants.WorkflowDocumentPlaceHolderText
      };
    },
    editReferencesTooltip(this: any): EditReferencesButtonTooltipModel | null {
      if (this.isWorkFlowJobDirty) {
        return {
          disabledTooltipMessage: NotificationConstants.CannotEditDocumentLinkedToUpdatedWorkflowJob,
          important: false
        };
      } else {
        return null;
      }
    },
    isArchiveQueueJob(this: any) {
      return (this.workflowJob as WorkflowJobModel).queueComponentName === ComponentConstants.Workflow.ArchiveQueue;
    },
    getNextJobText(this: any) {
      return this.isArchiveQueueJob ? 'Automatically open the next job is not available for this archive queue' : ' Automatically open the next job';
    }
  },
  components: {
    HorizontalWorkflowJobTabs,
    VerticalWorkflowJobTabs,
    DocumentViewer,
    WorkflowButtons,
    WorkflowJobLock,
    Splitpanes
  }
});
